import styled from "@emotion/styled";
import { SecondaryText } from "@silvertours/front-shared";
var Category = /*#__PURE__*/ styled("div", {
    target: "e7ripzs0"
})("margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[70];
}, ";");
var Details = /*#__PURE__*/ styled("div", {
    target: "e7ripzs1"
})("gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");
var Pricing = /*#__PURE__*/ styled("div", {
    target: "e7ripzs2"
})("display:flex;flex-direction:row;justify-content:space-between;");
var Dates = /*#__PURE__*/ styled(SecondaryText, {
    target: "e7ripzs3"
})("display:flex;flex-direction:row;justify-content:space-between;");
export { Category, Dates, Details, Pricing };
